<template>
    <div>
        <button
            type="button"
            class="btn btn-md is-ghost"
            href="#"
            @click.prevent="toggleModal"
        >
            Ändra status
        </button>
        <adaptive-form-modal
            name="update-project-status"
            primary-button-text="Ändra status"
            primary-button-class="is-primary"
            title="Ändra status för projektet"
            :redirect-to="redirectRoute"
            :action="actionRoute"
        >
            <div>
                <input
                    type="hidden"
                    name="_method"
                    value="patch"
                >
                <select-input
                    v-model="project.status"
                    name="status"
                    :options="options"
                    :opt-out-sorting="true"
                >
                    Ny status
                </select-input>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            options: {
                type: Object,
                required: true,
            },
        },
        computed: {
            actionRoute() {
                return route('api.sales-projects.update-status', this.project);
            },
            redirectRoute() {
                return route('admin.sales-projects.show', this.project);
            },
        },
        methods: {
            toggleModal() {
                this.$modal.show('update-project-status');
            },
        },
    };
</script>
